<div class="row d-flex justify-content-end">
    <button class="btn btn-sm btn-primary btn-previous" (click)="configureCurrentPage('Prev')" [disabled]="!pagination.prevBtn">
        <i class="fas fa-arrow-left"></i>
    </button>
    <button class="btn btn-sm btn-primary btn-next" (click)="configureCurrentPage('Next')" [disabled]="!pagination.nextBtn">
        <i class="fas fa-arrow-right"></i>
    </button>
</div>